// Secure token storage utility
// Uses sessionStorage instead of localStorage for better XSS protection
// Token is cleared when browser tab is closed

const TOKEN_KEY = 'admin_token';
const USER_KEY = 'admin_user';

export const authStorage = {
  setToken: (token) => {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
    }
  },

  getToken: () => {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  setUser: (user) => {
    if (user) {
      sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    }
  },

  getUser: () => {
    try {
      const user = sessionStorage.getItem(USER_KEY);
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  },

  clearAuth: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },

  isAuthenticated: () => {
    return !!sessionStorage.getItem(TOKEN_KEY);
  }
};

export default authStorage;
